<template>
    <div class="belong-page">
        <div class="query-conditions">
            <el-form :inline="true" @submit.native.prevent>
                <el-form-item>
                    <el-input
                        clearable
                        v-model.trim="query.name"
                        placeholder="请输入公司名称、产品名称"
                        @keyup.enter.native="handleFilter"
                        style="min-width: 370px"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        style="width: 132px; margin-right: 22px;"
                        type="primary"
                        @click="handleFilter"
                        :loading="table.loading"
                        >查询</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="query-data" v-loading="table.loading">
            <!-- list -->
            <div class="query-table" v-if="table.list.length > 0">
                <div class="query-list">
                    <el-table
                        style="width: 100%"
                        :data="table.list"
                        header-row-class-name="content-header-row"
                        header-cell-class-name="content-header-cell"
                    >
                        <el-table-column prop="product_name" label="产品名称">
                            <template slot-scope="scope">
                                <el-tag class="product-item" type="success">{{ scope.row.product_name }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="customer_id" label="客户编号" width="188">
                            <template slot-scope="scope">
                                <div>{{ scope.row.customer_id || '--' }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="company" label="广告主公司名称">
                            <template slot-scope="scope">
                                <div>{{ scope.row.company || '--' }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="username" label="归属人">
                            <template slot-scope="scope">
                                <div>{{ scope.row.username || '--' }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <el-pagination
                    :current-page.sync="query.page"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    @size-change="handlePageSizeChange"
                    @current-change="handleQueryPage"
                    layout="total, sizes, prev, pager, next"
                    :total="table.total"
                    style="margin-top: 30px; float: right"
                >
                </el-pagination>
            </div>

            <!-- no-data -->
            <Empty v-else tips="没有查询到归属哦～"> </Empty>
        </div>
    </div>
</template>
<script>
import Empty from '@/components/Empty';
import Request from '@/core/QuRequest';
const req = new Request();

export default {
    name: 'AdvertiserManageBelong',
    components: { Empty },
    data: () => ({
        query: {
            name: '',
            page: 1,
            page_size: 10
        },
        table: {
            list: [],
            total: 0,
            loading: false
        }
    }),

    methods: {
        handleFilter () {
            this.query.page = 1;
            this._getBelongList();
        },

        handlePageSizeChange (pageSize) {
            this.query.page_size = pageSize * 1;
            this._getBelongList();
        },

        handleQueryPage (page) {
            this.query.page = page * 1;
            this._getBelongList();
        },

        async _getBelongList () {
            try {
                const params = {
                    ...this.query
                };
                this.table.loading = true;
                // req
                const res = await req.send(req.Apis.sales.customerStage2.belong, params).fin(() => {
                    this.table.loading = false;
                });
                this.table.list = [...(res.data.data || [])];
                this.table.total = (res.data.total || 0) * 1;
            } catch (err) {
                this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
            }
        }
    },

    created () {
        this._getBelongList();
    }
};
</script>
<style lang="less" scoped>
.belong-page {
    /deep/ .content-header-row {
        height: 64px;
        color: #303133;
        font-weight: bold;
    }
    /deep/ .content-header-cell {
        background: #f9fbfe;
    }
    .product-item {
        height: 24px;
        line-height: 22px;
    }
}
</style>
